import Vue from 'vue'
import Vuex from 'vuex'
const { axios } = require('../plugins/axios');

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cart: [],
    shippingInfo: {
      method: 'pp',
      firstName: '',
      lastName: '',
      street: '',
      aptNumber: '',
      zip: '',
      city: '',
      country: 'pl'
    },
    additionalInfo: '',
    paymentMethod: 'btc',
    vacation: false,
    alertOn: false,
    PSC: false,
    alertText: '',
    globalDiscount: 0,
    paymentMethods: ['eth', 'btc', 'transfer'],
    shippingMethods: ['ip', 'pp', 'courier'],
    shippingPrices: {
      ip: 15,
      pp: 19,
      courier: 50
    },
    currency: 'PLN',
    telegramChannel: 'https://t.me/+DekziHHu-k1lOWQ0',
    telegramContact: 'https://t.me/Magic_Garden_20',
  },
  getters: {
    productInCart: (state) => (id) => {
      return state.cart.find(entry => entry.id == id);
    },
    cartSize: (state) => {
      return state.cart.length;
    },
    cartTotal: (state) => {
      let total = 0;
      for (let i = 0; i < state.cart.length; i++) {
        total += state.cart[i].price;
      }
      return total;
    },
    shippingCost: (state) => {
      return state.shippingPrices?.[state.shippingInfo.method] || 50;

    },
    paymentMethodLabel: (state) => {

      if (state.paymentMethod == 'btc') {
        return 'Bitcoin';
      }

      if (state.paymentMethod == 'psc') {
        return 'Paysafecard';
      }

      if (state.paymentMethod == 'eth') {
        return 'ETH';
      }

      if (state.paymentMethod == 'transfer') {
        return 'Przelew na konto/BLIK';
      }

      return 'Bitcoin';
    },
    shippingInfoComplete: (state) => {
      return (
        state.shippingInfo.firstName.length > 0 &&
        state.shippingInfo.lastName.length > 0 &&
        state.shippingInfo.street.length > 0 &&
        state.shippingInfo.zip.length > 0 &&
        state.shippingInfo.city.length > 0 &&
        state.shippingInfo.country.length > 0
      )
    },
  },
  mutations: {
    setCart(state, cart) {
      state.cart = cart;
    },
    setStoreInfo(state, data) {
      state.vacation = data.vacation;
      state.alertOn = data.alert;
      state.alertText = data.text;
      state.PSC = data.paysafecard;
      state.globalDiscount = data.global_discount;
      state.paymentMethods = data.paymentMethods;
      state.shippingMethods = data.shippingMethods;
      state.shippingPrices = data.shippingPrices;
      state.currency = data.currency;
      state.telegramChannel = data.telegramChannel;
      state.telegramContact = data.telegramContact;

    },
    setShippingInfo(state, info) {
      state.shippingInfo = info;
    },
    setPaymentMethod(state, method) {
      state.paymentMethod = method;
    },
  },
  actions: {
    fetchCart({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          axios.get("/api/cart/get").then(response => {
            if (response.data.success) {
              commit('setCart', response.data.cart)
              resolve(true);
            }
            else {
              commit('setCart', [])
              resolve(true);
            }
          }, error => {
            console.log(error);
            commit('setCart', [])
            reject(false);
          });
        }
        catch (error) {
          console.log('error ', error);
          commit('setCart', [])
          reject(false);
        }
      });
    },
    fetchStoreInfo({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          axios.get("/api/store/info").then(response => {
            if (response.status == 200) {
              commit('setStoreInfo', response.data)
              resolve(true);
            }
            else {
              resolve(true);
            }
          }, error => {
            console.log(error);

            reject(false);
          });
        }
        catch (error) {
          console.log('error ', error);
          reject(false);
        }
      });
    },
    clearCart({ commit }) {
      return new Promise((resolve) => {
        commit('setCart', []);
        resolve(true);
      });
    },
  },
  modules: {
  }
})
